// TODO: Temporary bridge for incremental refactoring.
// This service syncs the NgRx state to the legacy FormService and should be
// removed once the refactoring is complete.
import { Injectable, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormService } from "./form.service";
import {
  selectActiveWorkshopSystems,
  selectAllAvailablePackages,
  selectAvailableTimes,
  selectBasePackages,
  selectCarInfo,
  selectDealers,
  selectExternalTyreUrl,
  selectInsuranceProviders,
  selectProposalCustomer,
  selectProviderIds,
  selectTechUpdateStatus,
  selectVehicleSegment,
  selectWarningLights
} from "../state";
import { PackageTypeEnum } from "src/domain/client";

@Injectable({
  providedIn: "root"
})
export class StateSyncService implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private formService: FormService
  ) {}

  startSync(): void {
    console.log("State Sync Service has started.");

    // --- Step 1: About Vehicle ---
    this.store
      .select(selectCarInfo)
      .pipe(takeUntil(this.destroy$))
      .subscribe((carInfo) => {
        if (carInfo !== undefined) {
          this.formService.carInfoResponse = carInfo;
        }
      });

    this.store
      .select(selectTechUpdateStatus)
      .pipe(takeUntil(this.destroy$))
      .subscribe((techStatus) => {
        if (techStatus) {
          this.formService.techUpdateStatus = techStatus;
        }
      });

    this.store
      .select(selectProviderIds)
      .pipe(takeUntil(this.destroy$))
      .subscribe((ids) => {
        this.formService.providerIds = ids;
      });

    // --- Step 2: Workshop Selection --
    this.store
      .select(selectActiveWorkshopSystems)
      .pipe(takeUntil(this.destroy$))
      .subscribe((systems) => {
        if (systems) {
          this.formService.activeWorkshopSystemsResponse = systems;
        }
      });

    // --- Step 3: Find Dealer ---
    this.store
      .select(selectDealers)
      .pipe(takeUntil(this.destroy$))
      .subscribe((dealers) => {
        if (dealers) {
          this.formService.dealersResponse = dealers;
        }
      });

    // --- Step 4: Choose Specifications ---
    this.store
      .select(selectBasePackages)
      .pipe(takeUntil(this.destroy$))
      .subscribe((packages) => {
        this.formService.basePackagesResponse = packages;
      });
    this.store
      .select(selectInsuranceProviders)
      .pipe(takeUntil(this.destroy$))
      .subscribe((providers) => {
        this.formService.insuranceProvidersResponse = providers;
      });

    this.store
      .select(selectWarningLights)
      .pipe(takeUntil(this.destroy$))
      .subscribe((lights) => {
        this.formService.warningLightsResponse = lights;
      });

    this.store
      .select(selectExternalTyreUrl)
      .pipe(takeUntil(this.destroy$))
      .subscribe((urlResponse) => {
        this.formService.externalTyreUrlResponse = urlResponse;
      });

    this.store
      .select(selectVehicleSegment)
      .pipe(takeUntil(this.destroy$))
      .subscribe((segment) => {
        this.formService.segment = segment;
      });

    this.store
      .select(selectProposalCustomer)
      .pipe(takeUntil(this.destroy$))
      .subscribe((customer) => {
        if (customer) {
          this.formService.contactInformationForm.patchValue({
            firstName: customer.firstName,
            lastName: customer.lastName,
            phone: customer.phone,
            email: customer.email,
            smsChecked: customer.sendSms
          });
        }
      });

    // --- Step 4 & 5

    this.store
      .select(selectAllAvailablePackages)
      .pipe(takeUntil(this.destroy$))
      .subscribe((allPackages) => {
        const additionalTypes = [
          PackageTypeEnum.ServiceAdditional,
          PackageTypeEnum.PPS,
          PackageTypeEnum.DealerExtra,
          PackageTypeEnum.WashAndRecond
        ];
        if (allPackages) {
          this.formService.additionalPackagesResponse = allPackages.filter(
            (p) => additionalTypes.includes(p.type)
          );
        }
      });

    // --- Step 6: Time Selections
    this.store
      .select(selectAvailableTimes)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) this.formService.availableTimesResponse = data;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
